export default __webpack_public_path__ + "static/media/Yoast-logo.dd23bedd.svg";